import React, { Component } from "react";
import { Tooltip, Input, Badge } from "antd";
import { connect } from "dva";
import { stringify } from "qs";
import router from "umi/router";
import moment from "moment";
import Container from "@/components/Container";
import ListPage from "@/components/ListPage";
import OperateDropdown from "@/components/OperateDropdown";
import styles from "./index.less";

const { Search } = Input;

const { ListTable } = ListPage;

const statusMap = {
  "1": "default",
  "2": "processing",
  "3": "default"
};

const statusNameMap = {
  "1": "未开始",
  "2": "进行中",
  "3": "已结束"
};

@connect(({ evaluationList }) => ({
  ...evaluationList,
}))
class EvaluationView extends Component {
  constructor(props) {
    super(props);
    const columns = [
      {
        title: "参与项目名称",
        dataIndex: "projectName",
        width: 330,
        fixed: "left",
        render: projectName => (
          <Tooltip placement="top" title={projectName}>
            <span>
              {projectName?.length <= 20
                ? projectName
                : `${projectName?.substring(0, 20)}...`}
            </span>
          </Tooltip>
        )
      },
      {
        title: "状态",
        dataIndex: "status",
        render: status => {
          const statusCls = statusMap[status];
          const statusName = statusNameMap[status];
          return <Badge status={statusCls} text={statusName} />;
        }
      },
      {
        title: "开始日期",
        dataIndex: "startTime",
        render: startTime => moment(startTime).format("YYYY.MM.DD")
      },
      {
        title: "结束日期",
        dataIndex: "endTime",
        render: endTime => moment(endTime).format("YYYY.MM.DD")
      },
      {
        title: "操作",
        render: record => {
          const data = [
            {
              text: (
                <a onClick={event => this.handleEvaluate({ record, event })}>
                  立即评估
                </a>
              )
            }
          ];
          return <OperateDropdown data={data} />;
        }
      }
    ];

    this.state = {
      columns,
      searchName:''
    };
  }

  componentDidMount() {
    this.getList();
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: "tree/reset"
    });
  }

  // 分页改变
  handlePaginationChange = (page, pageSize) => {
    const params = { page, pageSize };
    this.getList(params);
  };

  getList = (pageInfo) => {
    const { dispatch } = this.props;
    const { searchName } = this.state
    dispatch({
      type: "evaluationList/fetchList",
      payload: {
        param: searchName,
        page:1,
        pageSize:10,
        ...pageInfo
      }
    });
  };

  handleJump = (id, record) => {
    const { projectId } = record;
    router.push(
      `/supervision/norm/evaluation/overview?${stringify({
        currentProjectId: projectId
      })}`
    );
  };

  handleEvaluate = ({ record, event }) => {
    if (event) {
      event.stopPropagation();
    }
    const { projectId } = record;
    router.push(
      `/supervision/norm/evaluation/my?${stringify({
        currentProjectId: projectId
      })}`
    );
  };

  handleSearch = val => {
    this.setState(
      {
        searchName: val
      },
      () => {
        this.getList();
      }
    );
  };

  renderHeader = () => {
    return (
      <div className="header">
        <Search
          style={{ width: 300 }}
          placeholder="请输入参与项目名称"
          onSearch={this.handleSearch}
        />
      </div>
    );
  };

  render() {
    const { projectList, spinProps, pageInfo } = this.props;
    const { columns } = this.state;

    const containerProps = {
      breStates: true,
      version: 2,
      isPathParams: true
    };

    const pageProps = {
      spinProps,
      className: styles.evaluation
    };

    const tableProps = {
      columns,
      rowKey: "projectId",
      list: projectList,
      pageInfo,
      onItemClick: this.handleJump,
      onPageChange: this.handlePaginationChange
    };

    return (
      <Container {...containerProps}>
        <ListPage {...pageProps}>
          {this.renderHeader()}
          <ListTable {...tableProps} />
        </ListPage>
      </Container>
    );
  }
}

export default EvaluationView;
